import { Box, Card, Divider, Grid, Stack, Typography } from "@mui/material";
import { StyledButtonMain } from "../common/Buttons";
import ThriveModal from "../common/ThriveModal";
import { useEffect, useState } from "react";
import UserEditor from "./UserEditor";
import OffboardUser from "./OffboardUser";
import { axiosInstance } from "../../utils/networking";

const UserManagement = () => {
  const [users, setUsers] = useState([]);
  const [userEditorOpen, setUserEditorOpen] = useState(false);
  const [editingUser, setEditingUser] = useState({ password: "" });
  const [offboardOpen, setOffboardOpen] = useState(false);
  const [offboardingUser, setOffboardingUser] = useState<any>(null);

  const handleOffboard = (user: any) => {
    setUserEditorOpen(false);
    setOffboardingUser(user);
    setOffboardOpen(true);
  };

  useEffect(() => {
    axiosInstance.get(`/user/allUsers`).then((res) => {
      setUsers(
        res.data.users.sort((a: any, b: any) =>
          a.firstName > b.firstName ? 1 : -1
        )
      );
    });
  }, []);
  const handleAddUser = () => {
    setUserEditorOpen(true);
    setEditingUser({ password: "" });
  };

  const handleEditUser = (user: any) => {
    setUserEditorOpen(true);
    setEditingUser(user);
  };

  const isDisabled = (user: any) =>
    user.role === "deleted" || user.status === "inactive";

  const activeUsers = users.filter((user: any) => !isDisabled(user));
  const disabledUsers = users.filter((user: any) => isDisabled(user));

  const renderUserCard = (user: any, disabled: boolean) => (
    <Grid key={user._id} item xs={3} sx={{ cursor: "pointer" }}>
      <Card
        sx={{
          padding: "20px",
          ...(disabled
            ? { backgroundColor: "#f5f5f5", color: "#9e9e9e" }
            : {}),
        }}
        onClick={() => {
          handleEditUser(user);
        }}
      >
        <Typography>
          {user.role === "admin"
            ? "Admin"
            : disabled
            ? "Disabled"
            : "Small Business Consultant"}
        </Typography>

        <Typography>{`${user.firstName} ${user.lastName}`}</Typography>
        {user.hideFromStats ? (
          <Typography variant="caption" sx={{ color: "#9e9e9e" }}>
            Hidden from stats
          </Typography>
        ) : null}
        <Typography>
          {disabled && user.deactivatedAt
            ? `Deactivated:${String(user.deactivatedAt).slice(0, 10)} `
            : user.last_login
            ? `Last Login:${user.last_login.slice(0, 10)} `
            : ""}
        </Typography>
      </Card>
    </Grid>
  );

  return (
    <Box>
      <Stack spacing={2}>
        <StyledButtonMain variant="contained" onClick={handleAddUser}>
          Add New User
        </StyledButtonMain>
        <Grid container spacing={2}>
          {activeUsers.map((user: any) => renderUserCard(user, false))}
        </Grid>

        {disabledUsers.length > 0 ? (
          <>
            <Divider sx={{ pt: 2 }} />
            <Typography variant="h6" sx={{ color: "#9E1F63" }}>
              {`Disabled Users (${disabledUsers.length})`}
            </Typography>
            <Grid container spacing={2}>
              {disabledUsers.map((user: any) => renderUserCard(user, true))}
            </Grid>
          </>
        ) : null}
      </Stack>
      <ThriveModal
        open={userEditorOpen}
        setOpen={setUserEditorOpen}
        contentComponent={
          <UserEditor
            setOpen={setUserEditorOpen}
            user={editingUser}
            onOffboard={handleOffboard}
          ></UserEditor>
        }
      ></ThriveModal>
      <ThriveModal
        open={offboardOpen}
        setOpen={setOffboardOpen}
        contentComponent={
          offboardingUser ? (
            <OffboardUser
              setOpen={setOffboardOpen}
              user={offboardingUser}
            ></OffboardUser>
          ) : (
            <></>
          )
        }
      ></ThriveModal>
    </Box>
  );
};

export default UserManagement;
